export const replaceValueNotExisting = (
  value: string | number,
): string | number => {
  return value || '-'
}

export const replaceValueNotExist = <T>(value: T): T => {
  return value || ('-' as unknown as T)
}
